import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
// import 'swiper/css/free-mode';

import Header from '../Component/Header';
import Footer from '../Component/Footer';
import Localocalexpertlist from "../Components/Localocalexpertlist";
import Localocalexpertcitylist from "../Components/Localocalexpertcitylist";

const Experts = () => {
      const [activeTab, setActiveTab] = useState('city');
  return (
    <>
      <Header />


            <main class="min-h-screen">
                <section className="bg-slate-900 text-white py-8">
                    <div className="container mx-auto px-4">
                        <div className="text-center mb-6">
                        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-3">
                            Connect with Local Travel Experts
                        </h1>
                        <p className="text-base md:text-lg text-gray-300 max-w-3xl mx-auto mb-6">
                            Get personalized travel advice from verified local experts who know
                            their destinations inside out
                        </p>
                        <div className="max-w-2xl mx-auto mb-5">
                            <div className="flex rounded-full bg-gray-700/50 border border-gray-600 overflow-hidden backdrop-blur-sm">
                            <div className="flex items-center pl-5">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-search h-4 w-4 text-gray-400"
                                >
                                <circle cx={11} cy={11} r={8} />
                                <path d="m21 21-4.3-4.3" />
                                </svg>
                            </div>
                            <input
                                className="flex h-14 w-full rounded-md border-input px-3 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 flex-1 border-0 bg-transparent text-white placeholder:text-gray-400 focus-visible:ring-0 focus-visible:ring-offset-0 text-base py-3"
                                placeholder="Where do you want to go?"
                                type="text"
                                defaultValue=""
                            />
                            <button className="inline-flex items-center justify-center whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 m-1.5 rounded-full bg-green-600 hover:bg-green-700 text-white px-6 py-2.5 font-semibold text-sm mt-2">
                                Find Experts
                            </button>
                            </div>
                        </div>
                        <div className="mb-6">
                            <p className="text-gray-400 mb-3 text-sm">Popular destinations:</p>
                            <div className="flex flex-wrap justify-center gap-2">
                            <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border h-9 rounded-full border-gray-600 bg-gray-800/30 hover:bg-gray-700/50 text-white hover:text-white backdrop-blur-sm text-sm py-1.5 px-3">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-map-pin h-3 w-3 mr-1.5"
                                >
                                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                <circle cx={12} cy={10} r={3} />
                                </svg>
                                Delhi
                            </button>
                            <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border h-9 rounded-full border-gray-600 bg-gray-800/30 hover:bg-gray-700/50 text-white hover:text-white backdrop-blur-sm text-sm py-1.5 px-3">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-map-pin h-3 w-3 mr-1.5"
                                >
                                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                <circle cx={12} cy={10} r={3} />
                                </svg>
                                Mumbai
                            </button>
                            <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border h-9 rounded-full border-gray-600 bg-gray-800/30 hover:bg-gray-700/50 text-white hover:text-white backdrop-blur-sm text-sm py-1.5 px-3">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-map-pin h-3 w-3 mr-1.5"
                                >
                                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                <circle cx={12} cy={10} r={3} />
                                </svg>
                                Bangalore
                            </button>
                            <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border h-9 rounded-full border-gray-600 bg-gray-800/30 hover:bg-gray-700/50 text-white hover:text-white backdrop-blur-sm text-sm py-1.5 px-3">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-map-pin h-3 w-3 mr-1.5"
                                >
                                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                <circle cx={12} cy={10} r={3} />
                                </svg>
                                Jaipur
                            </button>
                            <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border h-9 rounded-full border-gray-600 bg-gray-800/30 hover:bg-gray-700/50 text-white hover:text-white backdrop-blur-sm text-sm py-1.5 px-3">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-map-pin h-3 w-3 mr-1.5"
                                >
                                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                <circle cx={12} cy={10} r={3} />
                                </svg>
                                Goa
                            </button>
                            <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border h-9 rounded-full border-gray-600 bg-gray-800/30 hover:bg-gray-700/50 text-white hover:text-white backdrop-blur-sm text-sm py-1.5 px-3">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-map-pin h-3 w-3 mr-1.5"
                                >
                                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                <circle cx={12} cy={10} r={3} />
                                </svg>
                                Kerala
                            </button>
                            </div>
                        </div>
                        <div className="grid grid-cols-3 max-w-3xl mx-auto border-t border-gray-700 pt-5 mb-8">
                            <div className="text-center">
                            <div className="text-2xl md:text-3xl font-bold mb-1">200+</div>
                            <div className="text-gray-400 text-sm">Verified Experts</div>
                            </div>
                            <div className="text-center border-x border-gray-700">
                            <div className="text-2xl md:text-3xl font-bold mb-1">50+</div>
                            <div className="text-gray-400 text-sm">Destinations</div>
                            </div>
                            <div className="text-center">
                            <div className="text-2xl md:text-3xl font-bold mb-1">10k+</div>
                            <div className="text-gray-400 text-sm">Happy Travelers</div>
                            </div>
                        </div>
                        </div>
                        <div className="pt-2 pb-4 border-t border-gray-800">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-bold text-white">Featured Experts</h2>
                            <a
                            href="/experts/all"
                            className="text-green-500 hover:text-green-400 text-sm flex items-center"
                            >
                            View all experts{" "}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-chevron-right h-3 w-3 ml-1"
                            >
                                <path d="m9 18 6-6-6-6" />
                            </svg>
                            </a>
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
                            <a href="/experts/profile/rahul-sharma" className="group">
                            <div className="bg-gray-800/50 rounded-lg p-3 hover:bg-gray-700/50 transition-colors border border-gray-700/50">
                                <div className="flex flex-col items-center text-center">
                                <div className="relative w-14 h-14 mb-2">
                                    <div className="absolute inset-0 rounded-full overflow-hidden border-2 border-gray-600 group-hover:border-green-500 transition-colors">
                                    <img
                                        alt="Rahul Sharma"
                                        loading="lazy"
                                        decoding="async"
                                        data-nimg="fill"
                                        className="object-cover group-hover:scale-105 transition-transform duration-300"
                                        style={{
                                        position: "absolute",
                                        height: "100%",
                                        width: "100%",
                                        inset: 0,
                                        color: "transparent"
                                        }}
                                        src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/member-profile-1-Qd5JOMBYLc4AZ6oNEzdBL9WGqL2r4L.jpg"
                                    />
                                    </div>
                                </div>
                                <h3 className="text-white font-medium text-xs mb-1 leading-tight">
                                    Rahul Sharma
                                </h3>
                                <p className="text-gray-400 text-xs mb-2 leading-tight">
                                    Historical Tours
                                </p>
                                <div className="flex items-center text-gray-500 text-xs">
                                    <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-map-pin h-2.5 w-2.5 mr-1"
                                    >
                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                    <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span>Delhi</span>
                                </div>
                                </div>
                            </div>
                            </a>
                            <a href="/experts/profile/priya-malhotra" className="group">
                            <div className="bg-gray-800/50 rounded-lg p-3 hover:bg-gray-700/50 transition-colors border border-gray-700/50">
                                <div className="flex flex-col items-center text-center">
                                <div className="relative w-14 h-14 mb-2">
                                    <div className="absolute inset-0 rounded-full overflow-hidden border-2 border-gray-600 group-hover:border-green-500 transition-colors">
                                    <img
                                        alt="Priya Malhotra"
                                        loading="lazy"
                                        decoding="async"
                                        data-nimg="fill"
                                        className="object-cover group-hover:scale-105 transition-transform duration-300"
                                        style={{
                                        position: "absolute",
                                        height: "100%",
                                        width: "100%",
                                        inset: 0,
                                        color: "transparent"
                                        }}
                                        src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/member-1-bOpGjZCsPuoiXPcWozfOLLcloeHRto.jpg"
                                    />
                                    </div>
                                </div>
                                <h3 className="text-white font-medium text-xs mb-1 leading-tight">
                                    Priya Malhotra
                                </h3>
                                <p className="text-gray-400 text-xs mb-2 leading-tight">
                                    Food Tours
                                </p>
                                <div className="flex items-center text-gray-500 text-xs">
                                    <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-map-pin h-2.5 w-2.5 mr-1"
                                    >
                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                    <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span>Delhi</span>
                                </div>
                                </div>
                            </div>
                            </a>
                            <a href="/experts/profile/vikram-singh" className="group">
                            <div className="bg-gray-800/50 rounded-lg p-3 hover:bg-gray-700/50 transition-colors border border-gray-700/50">
                                <div className="flex flex-col items-center text-center">
                                <div className="relative w-14 h-14 mb-2">
                                    <div className="absolute inset-0 rounded-full overflow-hidden border-2 border-gray-600 group-hover:border-green-500 transition-colors">
                                    <img
                                        alt="Vikram Singh"
                                        loading="lazy"
                                        decoding="async"
                                        data-nimg="fill"
                                        className="object-cover group-hover:scale-105 transition-transform duration-300"
                                        style={{
                                        position: "absolute",
                                        height: "100%",
                                        width: "100%",
                                        inset: 0
                                        }}
                                        src="https://v0.blob.com/Yd9Ij.png"
                                    />
                                    </div>
                                </div>
                                <h3 className="text-white font-medium text-xs mb-1 leading-tight">
                                    Vikram Singh
                                </h3>
                                <p className="text-gray-400 text-xs mb-2 leading-tight">
                                    Photography Tours
                                </p>
                                <div className="flex items-center text-gray-500 text-xs">
                                    <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-map-pin h-2.5 w-2.5 mr-1"
                                    >
                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                    <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span>Mumbai</span>
                                </div>
                                </div>
                            </div>
                            </a>
                            <a href="/experts/profile/anjali-gupta" className="group">
                            <div className="bg-gray-800/50 rounded-lg p-3 hover:bg-gray-700/50 transition-colors border border-gray-700/50">
                                <div className="flex flex-col items-center text-center">
                                <div className="relative w-14 h-14 mb-2">
                                    <div className="absolute inset-0 rounded-full overflow-hidden border-2 border-gray-600 group-hover:border-green-500 transition-colors">
                                    <img
                                        alt="Anjali Gupta"
                                        loading="lazy"
                                        decoding="async"
                                        data-nimg="fill"
                                        className="object-cover group-hover:scale-105 transition-transform duration-300"
                                        style={{
                                        position: "absolute",
                                        height: "100%",
                                        width: "100%",
                                        inset: 0
                                        }}
                                        src="https://v0.blob.com/Yd9Ij.png"
                                    />
                                    </div>
                                </div>
                                <h3 className="text-white font-medium text-xs mb-1 leading-tight">
                                    Anjali Gupta
                                </h3>
                                <p className="text-gray-400 text-xs mb-2 leading-tight">
                                    Shopping Tours
                                </p>
                                <div className="flex items-center text-gray-500 text-xs">
                                    <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-map-pin h-2.5 w-2.5 mr-1"
                                    >
                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                    <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span>Bangalore</span>
                                </div>
                                </div>
                            </div>
                            </a>
                            <a href="/experts/profile/arjun-kapoor" className="group">
                            <div className="bg-gray-800/50 rounded-lg p-3 hover:bg-gray-700/50 transition-colors border border-gray-700/50">
                                <div className="flex flex-col items-center text-center">
                                <div className="relative w-14 h-14 mb-2">
                                    <div className="absolute inset-0 rounded-full overflow-hidden border-2 border-gray-600 group-hover:border-green-500 transition-colors">
                                    <img
                                        alt="Arjun Kapoor"
                                        loading="lazy"
                                        decoding="async"
                                        data-nimg="fill"
                                        className="object-cover group-hover:scale-105 transition-transform duration-300"
                                        style={{
                                        position: "absolute",
                                        height: "100%",
                                        width: "100%",
                                        inset: 0
                                        }}
                                        src="https://v0.blob.com/Yd9Ij.png"
                                    />
                                    </div>
                                </div>
                                <h3 className="text-white font-medium text-xs mb-1 leading-tight">
                                    Arjun Kapoor
                                </h3>
                                <p className="text-gray-400 text-xs mb-2 leading-tight">
                                    Adventure Tours
                                </p>
                                <div className="flex items-center text-gray-500 text-xs">
                                    <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-map-pin h-2.5 w-2.5 mr-1"
                                    >
                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                    <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span>Goa</span>
                                </div>
                                </div>
                            </div>
                            </a>
                            <a href="/experts/profile/meera-reddy" className="group">
                            <div className="bg-gray-800/50 rounded-lg p-3 hover:bg-gray-700/50 transition-colors border border-gray-700/50">
                                <div className="flex flex-col items-center text-center">
                                <div className="relative w-14 h-14 mb-2">
                                    <div className="absolute inset-0 rounded-full overflow-hidden border-2 border-gray-600 group-hover:border-green-500 transition-colors">
                                    <img
                                        alt="Meera Reddy"
                                        loading="lazy"
                                        decoding="async"
                                        data-nimg="fill"
                                        className="object-cover group-hover:scale-105 transition-transform duration-300"
                                        style={{
                                        position: "absolute",
                                        height: "100%",
                                        width: "100%",
                                        inset: 0
                                        }}
                                        src="https://v0.blob.com/Yd9Ij.png"
                                    />
                                    </div>
                                </div>
                                <h3 className="text-white font-medium text-xs mb-1 leading-tight">
                                    Meera Reddy
                                </h3>
                                <p className="text-gray-400 text-xs mb-2 leading-tight">
                                    Cultural Experiences
                                </p>
                                <div className="flex items-center text-gray-500 text-xs">
                                    <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-map-pin h-2.5 w-2.5 mr-1"
                                    >
                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                    <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span>Kerala</span>
                                </div>
                                </div>
                            </div>
                            </a>
                        </div>
                        </div>
                    </div>
                </section>

                <section className="py-16 bg-white">
                    <div className="container mx-auto px-4 md:px-6">
                        <div className="text-center mb-16">
                        <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-50 border border-green-200 rounded-full text-green-700 text-sm font-medium mb-6">
                            <div className="w-2 h-2 bg-green-500 rounded-full" />
                            How It Works
                        </div>
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                            Connect with Experts in{" "}
                            <span className="text-green-600">4 Simple Steps</span>
                        </h2>
                        <p className="text-gray-600 max-w-2xl mx-auto text-lg">
                            Our streamlined process makes finding and working with travel experts
                            effortless
                        </p>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        <div className="relative group">
                            <div className="hidden lg:block absolute top-12 left-full w-full h-px bg-gradient-to-r from-green-200 to-green-100 z-0" />
                            <div className="relative bg-white border border-gray-100 rounded-2xl p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 z-10">
                            <div className="absolute -top-3 -left-3 w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold shadow-lg">
                                01
                            </div>
                            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-green-200 transition-colors">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-search w-6 h-6 text-green-600"
                                >
                                <circle cx={11} cy={11} r={8} />
                                <path d="m21 21-4.3-4.3" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                Find Your Expert
                            </h3>
                            <p className="text-gray-600 text-sm leading-relaxed">
                                Browse verified travel experts by destination or specialty to find
                                your perfect match.
                            </p>
                            </div>
                        </div>
                        <div className="relative group">
                            <div className="hidden lg:block absolute top-12 left-full w-full h-px bg-gradient-to-r from-green-200 to-green-100 z-0" />
                            <div className="relative bg-white border border-gray-100 rounded-2xl p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 z-10">
                            <div className="absolute -top-3 -left-3 w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold shadow-lg">
                                02
                            </div>
                            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-green-200 transition-colors">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-calendar w-6 h-6 text-green-600"
                                >
                                <path d="M8 2v4" />
                                <path d="M16 2v4" />
                                <rect width={18} height={18} x={3} y={4} rx={2} />
                                <path d="M3 10h18" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                Book a Session
                            </h3>
                            <p className="text-gray-600 text-sm leading-relaxed">
                                Schedule a consultation at your convenience with instant booking
                                confirmation.
                            </p>
                            </div>
                        </div>
                        <div className="relative group">
                            <div className="hidden lg:block absolute top-12 left-full w-full h-px bg-gradient-to-r from-green-200 to-green-100 z-0" />
                            <div className="relative bg-white border border-gray-100 rounded-2xl p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 z-10">
                            <div className="absolute -top-3 -left-3 w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold shadow-lg">
                                03
                            </div>
                            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-green-200 transition-colors">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-message-circle w-6 h-6 text-green-600"
                                >
                                <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                Connect &amp; Plan
                            </h3>
                            <p className="text-gray-600 text-sm leading-relaxed">
                                Get personalized recommendations and custom itineraries tailored to
                                your needs.
                            </p>
                            </div>
                        </div>
                        <div className="relative group">
                            <div className="relative bg-white border border-gray-100 rounded-2xl p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 z-10">
                            <div className="absolute -top-3 -left-3 w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold shadow-lg">
                                04
                            </div>
                            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-green-200 transition-colors">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-map-pin w-6 h-6 text-green-600"
                                >
                                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                <circle cx={12} cy={10} r={3} />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                Travel with Confidence
                            </h3>
                            <p className="text-gray-600 text-sm leading-relaxed">
                                Enjoy your journey with expert guidance and 24/7 support throughout
                                your trip.
                            </p>
                            </div>
                        </div>
                        </div>
                        <div className="text-center mt-12">
                        <button className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-xl font-medium transition-colors">
                            Start Your Journey
                        </button>
                        </div>
                    </div>
                </section>




                <Localocalexpertcitylist />
                
              
                <Localocalexpertlist />

                

                <section className="py-20 bg-green-50">
                    <div className="container mx-auto px-4">
                        <div className="max-w-4xl mx-auto text-center">
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                            Ready to Plan Your Perfect Trip?
                        </h2>
                        <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
                            Connect with a local expert today and start creating unforgettable
                            travel experiences tailored just for you
                        </p>
                        <div className="flex flex-wrap justify-center gap-4 mb-12">
                            <div className="flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow-sm border border-gray-100">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-circle-check-big h-5 w-5 text-green-600"
                            >
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                <path d="m9 11 3 3L22 4" />
                            </svg>
                            <span className="text-gray-700 font-medium">
                                Personalized Itineraries
                            </span>
                            </div>
                            <div className="flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow-sm border border-gray-100">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-circle-check-big h-5 w-5 text-green-600"
                            >
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                <path d="m9 11 3 3L22 4" />
                            </svg>
                            <span className="text-gray-700 font-medium">Local Insights</span>
                            </div>
                            <div className="flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow-sm border border-gray-100">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-circle-check-big h-5 w-5 text-green-600"
                            >
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                <path d="m9 11 3 3L22 4" />
                            </svg>
                            <span className="text-gray-700 font-medium">24/7 Support</span>
                            </div>
                            <div className="flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow-sm border border-gray-100">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-circle-check-big h-5 w-5 text-green-600"
                            >
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                <path d="m9 11 3 3L22 4" />
                            </svg>
                            <span className="text-gray-700 font-medium">
                                Authentic Experiences
                            </span>
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row justify-center gap-4">
                          
                            <a href="/how-it-works">
                            <button className="inline-flex items-center justify-center whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border bg-background hover:text-accent-foreground h-11 rounded-md border-gray-300 text-gray-700 hover:bg-gray-50 px-10 py-4 text-lg font-semibold">
                                How It Works
                            </button>
                            </a>
                        </div>
                        </div>
                    </div>
                </section>

                
                
               
            </main>


      <Footer />
    </>
  );
};

export default Experts;
